import { render, staticRenderFns } from "./UntriagedComplaints.vue?vue&type=template&id=623ddfe6&scoped=true&"
import script from "./UntriagedComplaints.vue?vue&type=script&lang=js&"
export * from "./UntriagedComplaints.vue?vue&type=script&lang=js&"
import style0 from "./UntriagedComplaints.vue?vue&type=style&index=0&id=623ddfe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ddfe6",
  null
  
)

export default component.exports